import { FeatureFlagChannel } from '@tableau/microview-communication-service/lib/src/channelDefinitions/FeatureFlagChannelDefinitions';

export enum FeatureFlag {
  collectionsSiteSetting = 'collectionsSiteSetting',
  extractMoveToTheWebEnabled = 'extractMoveToTheWebEnabled',
  datasourceCertificationEnabled = 'datasourceCertificationEnabled',
  metricsReferenceLineEnabled = 'metricsReferenceLineEnabled',
  metricsColorIndicatorsEnabled = 'metricsColorIndicatorsEnabled',
  metricsDateWindowEnabled = 'metricsDateWindowEnabled',
  metricsSpaceEnabled = 'metricsSpaceEnabled',
  metricsHistoricalComparisonsEnabled = 'metricsHistoricalComparisonsEnabled',
  metricsEditingEnabled = 'metricsEditingEnabled',
  personalSpaceEnabled = 'personalSpaceEnabled',
  databasesInProjectsEnabled = 'databasesInProjectsEnabled',
  databasesInProjectsPostMVPEnabled = 'databasesInProjectsPostMVPEnabled',
  searchEPT = 'searchEPT',
  searchProductMetrics = 'searchProductMetrics',
  tablesInProjectsEnabled = 'tablesInProjectsEnabled',
  tablesInProjectsUIEnabled = 'tablesInProjectsUIEnabled',
  genericMicroview = 'genericMicroview',
  offspringPostMVP224 = 'offspringPostMVP224',
  predictiveModelEnabled = 'prometheusPredictiveModelEnabled',
  smarterSearchEnabled = 'smarterSearchEnabled',
}

export class FeatureFlagService {
  private featureFlagChannel = new FeatureFlagChannel();
  public static instance = new FeatureFlagService();

  public getValue(featureFlag: FeatureFlag): boolean {
    return this.featureFlagChannel.call({ featureFlag: featureFlag }).data?.featureFlagState || false;
  }
}
